import { observer } from "mobx-react";
import Card from "../../../../../components/layouts/card/card";
import { CARD_SPACING_VARIANT } from "../../../../../components/layouts/card/card.types";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR } from "../../../../../components/fonts/font-props";
import { Input } from "../../../../../components/inputs/input/input";
import { WalletStore } from "../../../../billing/stores/wallet/wallet-store";
import FontBody1 from "../../../../../components/fonts/font-body1/font-body1";

interface IWalletConfigurationSettingsProps {
    walletStore: WalletStore;
    validationErrors: () => string[];
}

const WalletConfigurationSettings: React.FC<IWalletConfigurationSettingsProps> = observer(({ 
    walletStore,
    validationErrors
 }) => {
    const { getTranslation } = useDashboardTranslation();
    const scope = 'dashboard-onboarding';
    
    return (
        <>
            <div className="wallet-configuration-settings-card-wrapper">
                <Card spacingVariant={CARD_SPACING_VARIANT.SMAll}>
                    <div className="wallet-configuration-auto-recharge-sentence">
                        <FontBody2 color={FONT_COLOR.PRIMARY2}>
                            {getTranslation("PAYMENT_METHOD_WILL_BW_CHARGED_WITH", scope)}
                        </FontBody2>
                        <span className="wallet-configuration-auto-recharge-inline-input">
                            <Input
                                adornment={walletStore.walletCurrencySymbol}
                                value={walletStore.rechargeAmount}
                                onChange={walletStore.setRechargeAmount}
                                type="number"
                                temp={true}
                                step={1}
                                validationCallback={walletStore.validateRechargeAmountEditor}
                                disabled={!walletStore.hasPaymentMethod}
                            />
                        </span>

                        <FontBody2 color={FONT_COLOR.PRIMARY2}>
                            {getTranslation("WHEN_BALANCE_FALLS_BELOW", scope)}
                        </FontBody2>
                        <span className="wallet-configuration-auto-recharge-inline-input">
                            <Input
                                adornment={walletStore.walletCurrencySymbol}
                                value={walletStore.rechargeThreshold}
                                onChange={walletStore.setMinimumThreshold}
                                type="number"
                                temp={true}
                                step={1}
                                validationCallback={walletStore.validateMinimumThresholdEditor}
                                disabled={!walletStore.hasPaymentMethod}
                            />
                        </span>
                    </div>
                </Card>
            </div>
            {validationErrors().length > 0 && <div className="wallet-configuration-auto-recharge-errors">
                { validationErrors().map(error => (
                        <FontBody1 key={error}>{error}</FontBody1>
                    ))}                               
                </div>
            }
        </>
    );
});

export default WalletConfigurationSettings;